export default "__VITE_ASSET__Cx7bYE9M__"